import { useGetList } from 'react-admin';

import type { Queue } from '@ragu-components/ord-types';

interface UseQueueRecordingConfsDataReturn {
  queues: Queue[];
  assignedQueueIds: string[];
  loaded: boolean;
}

export const useQueueRecordingConfsData = (confId: string): UseQueueRecordingConfsDataReturn => {
  const resource = `call_recording_confs/${confId}/queues`;
  const { data: queues } = useGetList<Queue>(resource, {
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'name', order: 'ASC' },
  });

  const assignedQueueIds: string[] = [];

  if (queues !== undefined) {
    for (const queue of queues) {
      assignedQueueIds.push(String(queue.id));
    }
  }

  return {
    queues: queues ?? [],
    assignedQueueIds,
    loaded: queues !== undefined,
  };
};
